import * as tsx from 'vue-tsx-support';
import { PropType, VNode } from 'vue';
import { HAlternateLayoutItem } from './HAlternateLayoutItem';
import { ResolvedLanugageData } from '~/server-middleware/data-server/adapter/ACCOAdapter/schemes';
import { AvailableLanguage } from '~/schemes';
import { mergeVNodeData } from '~/helpers';
import { AlternateLayoutModule } from '~/server-middleware/data-server/adapter/ACCOAdapter/@types';

export const HAlternateLayout = tsx.component({
  name: 'HAlternateLayout',
  functional: true,
  props: {
    value: {
      type: Object as PropType<
        ResolvedLanugageData<
          AlternateLayoutModule['properties'],
          AvailableLanguage
        >
      >,
      required: true,
    },
  },

  render(h, { props, data }): VNode {
    const { items } = props.value;

    // 画像があるアイテムのインデックスをトラック
    let imageItemCount = 0;

    return (
      <div
        {...mergeVNodeData(data, {
          staticClass: 'v-alternate-layout-module',
        })}>
        <div>
          {items.map((child) => {
            const hasImage = !!child.properties.image;
            const shouldReverse = hasImage && imageItemCount % 2 !== 0;

            if (hasImage) {
              imageItemCount++;
            }

            return (
              <HAlternateLayoutItem
                value={child.properties}
                reversed={shouldReverse}
                key={child.key}
              />
            );
          })}
        </div>
      </div>
    );
  },
});
